import React from 'react'

export const arkansasSetupVars = {
  siteId: 'arkansas',
  topScreenshotUrl: '/images/arkansas/marketing/Images/Export/Mockup@2x.png',
  pathPrefix: '/ar',
  menuHeader: "Discover Arkansas's Solution for:",
  appUrl: 'https://ar.headed2.com',
  logoImg: '/images/assets/arkansas/horizontal/dark.svg',
  headerTitle: `The Arkansas CareerExplorer is a system designed for Arkansas`,
  headerTitleDescription: (
    <div>
      <p>
        With information and reporting designed to support career readiness for
        Arkansas&#39;s in-demand careers.
      </p>
      <h4>
        With a <b>FREE</b> Headed2 account, you will have access to:
      </h4>
      <ul className="top-features">
        <li className="onetprofile">Occupation & College Info</li>
        <li className="financial-literacy">Financial Literacy Tools</li>
        <li className="onetassess">Self Assessments</li>
        <li className="plantool">Planning Tools</li>
      </ul>
    </div>
  ),
  sponsorMsg: (
    <span>
      The <b>Arkansas CareerExplorer</b> is a state-approved career exploration and
      planning system designed to support Student Success Plans.
    </span>
  ),
  sponsorImg: `/images/arkansas/marketing/Images/ADE_Commissioner_s_Memo.png`,
  //webinarUrl: "https://h2-training.s3.amazonaws.com/AR-Introduction-0619-v1.1.mp4",
  brochureDownloadImg: '/images/www/new/homepage/Homepage-Download-AR@2x.png',
  brochureDownloadUrl: `https://drive.google.com/uc?export=download&id=1-cZHihytT72eFVrgu2jMvCBjHohPJesb`,
  otherSites: [
    {
      url: 'https://www.cacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/CCZ-logo.svg'
    },
    {
      url: 'https://www.pacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/PA-logo.svg'
    },
    {
      url: 'https://nv.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/NV-logo.svg'
    },
    {
      url: 'https://va.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/VA-logo.svg'
    }
  ]
}
